(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporting-casnonreleve', {
            parent: 'entity',
            url: '/reporting-casnonreleve?page&sort&searchQuery&agenceId&cluster&casNonReleve&collecteur&startDate&endDate',
            data: {
                authorities: ['ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.reportingAgence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/reporting-casnonreleve/reporting-casnonreleve.html',
                    controller: 'ReportingCasNonReleveController',
                    controllerAs: 'vm'
                }
            },

            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('reportingGlobal');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('casNonReleve');
                    $translatePartialLoader.addPart('cluster');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
